@if (isLoading()) {
<div class="grid-loader-overlay">
    <div class="sg-loaders">
        <div class="sg-loaders__item sg-loaders__item--block sg-loaders__item--blue">
            <div class="gov-loader gov-loader--block gov-loader--inversed">
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
                <span>&nbsp;</span>
            </div>
        </div>
    </div>
</div>
}